export interface ProductDetailsPageState {
  selectedPriceReference: string;

  accordionProductCode: string;
  accordionLoading: boolean;
  accordionType: PdpAccordionType | null;
}

export enum PdpAccordionType {
  SUCCESSOR = 1,
  ALTERNATIVE,
}
